import { cn } from "@/lib/utils";
import { resolveUserAvatar } from "@/lib/userAvatar";

interface UserInitialAvatarProps {
  email?: string | null;
  userId?: string | null;
  className?: string;
  /** Override computed title (defaults to email or userId). */
  title?: string;
}

export function UserInitialAvatar({
  email,
  userId,
  className,
  title: titleOverride,
}: UserInitialAvatarProps) {
  const { letter, color, title } = resolveUserAvatar({ email, userId });
  const label = titleOverride ?? title ?? "Unknown user";

  return (
    <span
      className={cn(
        "inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full",
        "text-[9px] font-bold leading-none text-white",
        className
      )}
      style={{ backgroundColor: color }}
      title={label}
      aria-label={label}
      data-testid="user-initial-avatar"
    >
      {letter}
    </span>
  );
}
